import { Action } from "redux";
import { AUTH_ACTION } from '../interface';

export interface ActionWithPayload extends Action {
    type: string;
    payload: {
        data: any,
        status: number
    };
}

//@ts-ignore
export default function auth_reducer(authState: { authData: any, isLoading: Boolean, errors: any, loggedIn: Boolean } =
    { authData: null, isLoading: false, errors: null, loggedIn: false }, action: ActionWithPayload) {
    switch (action.type) {
        case AUTH_ACTION.START_LOADING:
            return { ...authState, isLoading: true };
        case AUTH_ACTION.END_LOADING:
            return { ...authState, isLoading: false };
        case AUTH_ACTION.ERROR:
            console.log("data in payload");
            // console.log(action.payload);
            if (action.payload.status === 400) {
                return { ...authState, errors: "パスワードが正しくないです。" }
            }
            else if (action.payload.status === 401) {
                return { ...authState, errors: "メールアドレスが認識できません。" }
            }
            else if (action.payload.status === 403) {
                return { ...authState, errors: "まだ承認されていません。" }
            } else {
                return { ...authState, errors: "null" }
            }
        case AUTH_ACTION.SIGNUP_ERROR:
            console.log("data in payload");
            // console.log(action.payload);
            if (action.payload.status === 400) {
                return { ...authState, errors: "同じメールアドレスのアカウントが存在します。もう一度、他のメールアドレスを使い登録お願いします。" }
            } else {
                return { ...authState, errors: null };
            }

        case AUTH_ACTION.END_ERROR:
            return { ...authState, errors: null };
        case AUTH_ACTION.AUTH:
            console.log(action);
            localStorage.setItem('profile', JSON.stringify({ ...action?.payload }));
            console.log("inside reducer");
            console.log(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));
            return { ...authState, authData: action.payload.data, errors: null, loggedIn: true };

        case AUTH_ACTION.LOGOUT:
            localStorage.clear();
            return { ...authState, authData: null, isLoading: false, errors: null, loggedIn: false };

        default:
            return authState;
    }
};